import { MemberType } from '@hc-frontend/entities'

function getMemberIdBySuffix(suffix = '') {
  switch (suffix) {
    case '':
      return {
        id: MemberType.Applicant.toLowerCase(),
        type: MemberType.Applicant
      }
    case 's':
      return {
        id: MemberType.Spouse.toLowerCase(),
        type: MemberType.Spouse
      }
    default:
      return {
        id: `${MemberType.Child.toLowerCase()}_${suffix}`,
        type: MemberType.Child
      }
  }
}

export default getMemberIdBySuffix
